import { EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import { eachLineSeriesModel } from './helper';
import { DvLineSeriesModel } from './type';

function parseEndLabelZIndex(model: DvLineSeriesModel, chart: ExtensionAPI) {
  // 获取每个line模型对应的视图层
  const view = chart.getViewOfSeriesModel(model);
  // 获取折线对应的endLabel数据模型
  const isShowEndLabel = model.get(['endLabel', 'show']);
  // 获取配置项中的数据dvZ
  const dvEndLabelZ = model.get(['endLabel', 'dvZ']);

  if (!isShowEndLabel || !view._endLabel) {
    return;
  }

  // 从视图层修改endLabel的层级
  (view._endLabel as Element).attr({
    z: dvEndLabelZ
  });
}

function parseEndLabelRotate(model: DvLineSeriesModel, chart: ExtensionAPI) {
  const lineView = chart.getViewOfSeriesModel(model);
  const isEndLabelShow = model.get(['endLabel', 'show']);
  const dvRotate = model.get(['endLabel', 'dvRotate']);
  if (!isEndLabelShow) {
    return;
  }
  if (dvRotate !== 'auto') {
    return;
  }
  const first = [lineView._points[0], lineView._points[1]];
  const second = [lineView._points[2], lineView._points[3]];
  const rotate2 = Math.atan((first[1] - second[1]) / (second[0] - first[0]));
  if (!lineView._endLabel) {
    return;
  }
  lineView._endLabel.attr({
    rotation: rotate2
  });
}

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('series:afterupdate', (ecModel, api) => {
    eachLineSeriesModel(ecModel, model => {
      parseEndLabelZIndex(model, api);
      parseEndLabelRotate(model, api);
    });
  });
}
